import { useEffect, useRef } from 'react';
import { useUnstableGlobalHref } from 'expo-router';
import { publicDocumentHref, usesPublicDocuments } from '@/lib/publicPageNavigation';

export default function usePublicPageHandoff(pathname) {
  // Use Expo's complete destination, including its query/hash, before removing
  // the app navigator. Its browser history can briefly reset to the root when
  // that navigator unmounts; that root is not the user's requested page.
  const href = useUnstableGlobalHref();
  let target = usesPublicDocuments() && publicDocumentHref(href || pathname);
  if (target) {
    const url = new URL(target, window.location.origin);
    // React Navigation adds this reserved nesting parameter to a pending
    // route. It is not part of the requested public document's query string.
    url.searchParams.delete('initial');
    target = url.pathname + url.search + url.hash;
  }
  const pending = useRef(null);
  if (target && !pending.current) pending.current = target;
  const destination = pending.current;
  useEffect(() => {
    if (!destination) return;
    const timer = setTimeout(() => {
      window.location.replace(destination);
    }, 0);
    return () => clearTimeout(timer);
  }, [destination]);
  // Never mount the retained public React screen while requesting its document.
  return Boolean(destination);
}
